import { SELECIONAR_ITINERARIOS } from '../../actions/types'

const initialState = undefined
const estadoInicial = null;

export default function reducerItinerariosSelecionados(state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_ITINERARIOS: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
